export const SIDE_MENU_MOBILE_ID = "SIDE_MENU_MOBILE_ID";
